<template>
  <div class="container" :style="`background-image:url(${bg})`">
    <div class="km button" @click="openLink('qy')">
      <img :src="linkicon" alt="" /> <span>企业馆</span>
    </div>
    <div class="qy button" @click="openLink('km')">
      <img :src="linkicon" alt="" /> <span>开幕式馆</span>
    </div>
    <div class="zt button" @click="openLink('zt')">
      <img :src="linkicon" alt="" /> <span>主题日馆</span>
    </div>
    <div class="qj button" @click="openLink('sz')">
      <img :src="linkicon" alt="" /> <span>十周年馆</span>
    </div>
    <div class="wl button" @click="openLink('wl')">
      <img :src="linkicon" alt="" /> <span>网络安全宣传馆</span>
    </div>
    <div :class="'mobile-back-icon-box'" @click="backPage">
      <img :src="backIcon" class="back-icon" />
    </div>
  </div>
</template>

<script>
import bg from "../assets/image/mbgbase64";
import linkicon from "../assets/icon/网络.png";
import videoicon from "../assets/icon/视频.png";
import backIcon from "../assets/icon/back.png";
export default {
  name: "MnavPage",
  data() {
    return {
      bg,
      linkicon,
      backIcon,
      videoicon,
      openLinkMap: {
        qy: "https://ve.cool360.com/cybersecuritylist/index.html",
        km: "https://ve.cool360.com/OpeningCeremony/index.html",
        zt: "https://ve.cool360.com/CampusDay/index.html",
        sz: "https://ve.cool360.com/InternetPower/index.html",
        wl: "https://ve.cool360.com/CyberSecurityAdvocacy/index.html",
      },
      bitchfuck: true,
    };
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
    openLink(name) {
      if (name === "zt" && +new Date().getTime() < new Date("2022/09/06").getTime()) {
        alert("主题日将于2022年9月6日开放，敬请期待");
        return;
      }
      window.open(this.openLinkMap[name]);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: cover;
  .km {
    top: 70vh;
    left: 8.44667vw;
  }
  .qy {
    top: 70vh;
    left: 54.22334vw;
  }
  .zt {
    top: 80vh;
    left: 8.44667vw;
  }
  .qj {
    top: 80vh;
    left: 54.22334vw;
  }
  .wl {
    top: 90vh;
    left: calc(50% - 22vw);
    width: 44vw !important;
  }
  .button {
    position: absolute;
    width: 37.33vw;
    height: 10.667vw;
    line-height: 0px;
    text-align: center;
    color: #0083d4;
    border-radius: 5px;
    background-color: #fff;
    cursor: pointer;
    img {
      display: inline-block;
      width: 25px;
      height: 25px;
      vertical-align: middle;
    }
    span {
      font-size: 18px;
      font-weight: 600;
      line-height: 40px;
      vertical-align: middle;
    }
  }
  .mobile-back-icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 25px;
    top: 20px;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.25);
    border: none;
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
    outline: none;
    img {
      user-select: none;
      -webkit-user-select: none; /*禁用手机浏览器的用户选择功能 */
      -moz-user-select: none;
      width: 25px;
      height: 25px;
    }
  }
}
</style>